import { render, staticRenderFns } from "./DealerDashboard.vue?vue&type=template&id=2e2b66b9&scoped=true"
import script from "./DealerDashboard.vue?vue&type=script&lang=ts"
export * from "./DealerDashboard.vue?vue&type=script&lang=ts"
import style0 from "./DealerDashboard.vue?vue&type=style&index=0&id=2e2b66b9&prod&lang=css"
import style1 from "./DealerDashboard.vue?vue&type=style&index=1&id=2e2b66b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b66b9",
  null
  
)

export default component.exports